import {
  type EquityPosition,
  PositionResult,
  PositionSide,
  SUCCESS_POSITION_RESULT,
  UpdateType,
} from "@/generated/TradingGateway"

export const mockPositions: EquityPosition[] = [
  {
    assetId: "904837e3-3b76-47ec-b432-046db621571b",
    symbol: "AAPL",
    exchange: "NASDAQ",
    assetClass: "us_equity",
    avgEntryPrice: "93.5",
    qty: "8",
    side: PositionSide.Long,
    marketValue: "600.0",
    costBasis: "500.0",
    unrealizedPl: "100.0",
    unrealizedPlpc: "0.20",
    unrealizedIntradayPl: "10.0",
    unrealizedIntradayPlpc: "0.0084",
    currentPrice: "120.0",
    lastDayPrice: "119.0",
    changeToday: "0.0084",
  },
  {
    assetId: "cc1fdcce-d8ae-4d2b-9c72-142c18a9dbe0",
    symbol: "TSLA",
    exchange: "NASDAQ",
    assetClass: "us_equity",
    avgEntryPrice: "67.25",
    qty: "10",
    side: PositionSide.Long,
    marketValue: "421.35",
    costBasis: "500.0",
    unrealizedPl: "-120.0",
    unrealizedPlpc: "0.20",
    unrealizedIntradayPl: "10.0",
    unrealizedIntradayPlpc: "0.0084",
    currentPrice: "120.0",
    lastDayPrice: "119.0",
    changeToday: "-0.0004",
  },
  {
    assetId: "e24458a2-145d-45ea-a747-4a28155232f7",
    symbol: "AMZN",
    exchange: "NASDAQ",
    assetClass: "us_equity",
    avgEntryPrice: "34.01",
    qty: "15",
    side: PositionSide.Short,
    marketValue: "50.12",
    costBasis: "500.0",
    unrealizedPl: "20.0",
    unrealizedPlpc: "0.20",
    unrealizedIntradayPl: "10.0",
    unrealizedIntradayPlpc: "0.0084",
    currentPrice: "120.0",
    lastDayPrice: "119.0",
    changeToday: "0.014",
  },
  {
    assetId: "21500e75-3da8-4e21-9d5e-e6c1bca1e6f5",
    symbol: "MSFT",
    exchange: "NASDAQ",
    assetClass: "us_equity",
    avgEntryPrice: "101.35",
    qty: "5",
    side: PositionSide.Long,
    marketValue: "923.05",
    costBasis: "500.0",
    unrealizedPl: "100.0",
    unrealizedPlpc: "0.20",
    unrealizedIntradayPl: "10.0",
    unrealizedIntradayPlpc: "0.0084",
    currentPrice: "120.0",
    lastDayPrice: "119.0",
    changeToday: "0.0020",
  },
  {
    assetId: "51aa426d-946b-44d1-a10a-1f9680cbe004",
    symbol: "NVDA",
    exchange: "NASDAQ",
    assetClass: "us_equity",
    avgEntryPrice: "120.24",
    qty: "10",
    side: PositionSide.Long,
    marketValue: "350.12",
    costBasis: "500.0",
    unrealizedPl: "-120.0",
    unrealizedPlpc: "0.20",
    unrealizedIntradayPl: "10.0",
    unrealizedIntradayPlpc: "0.0084",
    currentPrice: "120.0",
    lastDayPrice: "119.0",
    changeToday: "0",
  },
]

export const mockEvents: PositionResult[] = mockPositions.map((payload) => ({
  type: SUCCESS_POSITION_RESULT,
  payload: { updateType: UpdateType.StateOfTheWorld, payload },
}))
